// extracted by mini-css-extract-plugin
export default {"header":"TableScrollArea_header__Yh+cj","scrolled":"TableScrollArea_scrolled__3T7Ig"};